import { render } from "./CartListItem.vue?vue&type=template&id=decedd3e&scoped=true"
import script from "./CartListItem.vue?vue&type=script&lang=js"
export * from "./CartListItem.vue?vue&type=script&lang=js"

import "./CartListItem.vue?vue&type=style&index=0&id=decedd3e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-decedd3e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
